import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type TradeOutboxEventCountsResult = QueryAtomResult<
  typeof tradeOutboxEventCountsQueryAtom
>;

export const tradeOutboxEventCountsQueryAtom = createQueryAtomFactory(
  'auditLog.tradeOutboxEventCounts',
  () => ({
    tradeOutboxEventCounts: {
      booking: true,
      load: true,
      salesOrder: true,
      purchaseOrder: true,
    },
  }),
  {
    select: ({ tradeOutboxEventCounts }) => tradeOutboxEventCounts,
  },
);
